import { useEffect, useState, useRef } from "react";
import { useMobileDetect } from "../../hooks";
import { useErrorStore } from "../../store/useErrorStore";

import { Box } from "@mui/material";

const PDF_DOCUMENT = '/Cria_de_quebrada_mobile_compressed.pdf';

export const ComoFuncionaFavela = () => {
    const isMobile = useMobileDetect();

    if (isMobile) {
        return <MobilePdfViewer />;
    }

    return (
        <Box
            sx={{
                display: "flex",
                flexDirection: "column",
                height: "100vh",
                overflow: "hidden",
                position: "relative",
                zIndex: "1",
                margin: 0,
                padding: 0,
                border: 0,
            }}
        >
            <iframe 
                src={PDF_DOCUMENT + '#toolbar=0&navpanes=0&scrollbar=0'}
                style={{
                    width: "100%",
                    height: "100%",
                    border: 0,
                    margin: 0,
                    padding: 0,
                }}
                allowFullScreen
                title="Cria de Quebrada"
            />
        </Box>
    );
};

const MobilePdfViewer = () => {
    const containerRef = useRef(null);
    
    const [pdfLoaded, setPdfLoaded] = useState(false);

    const showError = useErrorStore((state) => state.showError);

    useEffect(() => {
        if (!containerRef.current) return;

        if (!window.pdfjsLib) {
            const script = document.createElement("script");
            script.src = "https://cdnjs.cloudflare.com/ajax/libs/pdf.js/3.4.120/pdf.min.js";
            script.async = true;
            script.onload = () => {
                window.pdfjsLib.GlobalWorkerOptions.workerSrc = "https://cdnjs.cloudflare.com/ajax/libs/pdf.js/3.4.120/pdf.worker.min.js";
                setPdfLoaded(true);
            };
            document.head.appendChild(script);
        } else {
            setPdfLoaded(true);
        }
    }, []);

    useEffect(() => {
        if (!pdfLoaded || !containerRef.current) return;

        loadMobilePDF(containerRef, showError);
    }, [pdfLoaded, showError]);
    
    return (
        <Box
            sx={{
                display: "flex",
                flexDirection: "column",
                height: "100vh",
                overflow: "hidden",
                position: "relative",
                zIndex: "1",
                margin: 0,
                marginBottom: "40px",
                padding: 0,
                border: 0,
            }}
        >
            <div
                ref={containerRef}
                style={{
                    width: "100%",
                    height: "100%",
                    overflowY: "auto",
                    WebkitOverflowScrolling: "touch",
                    padding: "10px",
                    boxSizing: "border-box",
                }}
            />
        </Box>
    );
};

const loadMobilePDF = async (containerRef, showError) => {
    try {
        const pdf = await window.pdfjsLib.getDocument(PDF_DOCUMENT).promise;
        containerRef.current.innerHTML = '';
        
        for (let pageNum = 1; pageNum <= pdf.numPages; pageNum++) {
            const page = await pdf.getPage(pageNum);
            const viewport = page.getViewport({ scale: 1 });
            
            const containerWidth = containerRef.current.clientWidth || window.innerWidth;
            const scale = containerWidth / viewport.width;
            
            const devicePixelRatio = window.devicePixelRatio || 1;
            const qualityScale = scale * devicePixelRatio * 2;
            const scaledViewport = page.getViewport({ scale: qualityScale });
            
            const canvas = document.createElement('canvas');
            const context = canvas.getContext('2d');
            
            canvas.width = scaledViewport.width;
            canvas.height = scaledViewport.height;
            
            canvas.style.width = '100%';
            canvas.style.height = (scaledViewport.height / (devicePixelRatio * 2)) + 'px';
            canvas.style.display = 'block';
            canvas.style.marginBottom = '10px';
            
            containerRef.current.appendChild(canvas);
            
            await page.render({
                canvasContext: context,
                viewport: scaledViewport
            }).promise;
        }
    } catch (error) {
        showError(error);
    }
};
